$(document).ready(function () {
  if ($(".custom__select").length) {
    if ($(".custom__select").length > 1) {
      $(".custom__select").each(function () {
        let $this = $(this).not(".select-search");
        $this.select2({
          minimumResultsForSearch: -1,
        });
      });
    } else {
      $(".custom__select").select2({
        minimumResultsForSearch: -1,
      });
    }
  }

  if ($(".rating-head__select").length) {
    if ($(window).width() > 374) {
      $(".rating-head__select").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass:
          "custom__section__select__container custom__section__select__container--rating",
        dropdownAutoWidth: true,
        width: "auto",
      });
    } else {
      $(".rating-head__select").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass:
          "custom__section__select__container custom__section__select__container--rating",
      });
    }
  }

  // Селект bukmekerskie-kontori
  if ($(".custom__section__nav__select").length) {
    if ($(".custom__section__nav__select").length > 1) {
      $(".custom__section__nav__select").each(function () {
        let $this = $(this).not(".select-search");
        $this.select2({
          minimumResultsForSearch: -1,
          dropdownCssClass: "custom__section__select__container",
        });
      });
    } else {
      $(".custom__section__nav__select").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "custom__section__select__container",
      });
    }
  }

  if ($("#best_bk_margin").length) {
    $("#best_bk_margin").select2({
      minimumResultsForSearch: -1,
      dropdownCssClass:
        "custom__section__select__container custom__section__select__container--best_bk",
    });
  }

  if ($(".custom__section__nav__select--other").length) {
    $(".custom__section__nav__select--other").select2({
      minimumResultsForSearch: -1,
      dropdownCssClass:
        "custom__section__select__container custom__section__select__container--other",
    });
  }

  // селект отызвы БК
  if ($(".modal__review__select").length) {
    if ($(".modal__review__select").length > 1) {
      $(".modal__review__select").each(function () {
        let $this = $(this).not(".select-search");
        $this.select2({
          minimumResultsForSearch: -1,
          dropdownCssClass: "modal__review__select__container",
        });
      });
    } else {
      $(".modal__review__select").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "modal__review__select__container",
      });
    }
  }
});
